// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider[data-v-c45664d2]{position:absolute;left:1.5625rem;bottom:1.25rem}@media(min-width:80rem){.slider[data-v-c45664d2]{left:6.6875rem}}@media(min-width:90rem){.slider[data-v-c45664d2]{left:1.5625rem}}.slider[data-v-c45664d2] .v-slider--vertical{height:11.375rem}.slider[data-v-c45664d2] .v-slider__thumb-label{margin-left:.625rem;background:transparent!important;color:#666;height:.625rem!important}", ""]);
// Exports
module.exports = exports;
